<template>
  <div>
    <v-btn icon small @click.stop="dialog = true"
      v-if="this.iconError">
      <v-icon :color="ui.colorError"> description </v-icon>
    </v-btn>
    <v-dialog v-model="dialog" :max-width="ui.sizeWidthDialogSmall">
      <v-card :class="ui.bkgdColor">
        <v-card-title :class="ui.textTitle">
          Terms and Conditions
        </v-card-title>
        <v-card-text>
          <v-layout row :class="ui.textDescription">
            <v-flex xs4>
              <v-icon large :color="ui.colorWarning"> description </v-icon>
            </v-flex>
            <v-flex xs8>
              New non critical update to Terms and Conditions is available. Please review new conditions at the earliest convenience.
            </v-flex>
          </v-layout>
          <v-layout row class="mt-4"/>
          <v-layout row :class="ui.textDescription">
            <v-flex xs4>
              <v-icon large :color="ui.colorError"> description </v-icon>
            </v-flex>
            <v-flex xs8>
              Terms and Conditions Policy which is an agreement describing a relationship between user and system custodian. New or updated Terms of Use release is not agreed and user functionality is constrained.
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn :color="ui.btnColor" flat @click="dialog = false">
            <v-icon left> exit_to_app </v-icon>
            back
          </v-btn>
          <v-spacer/>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import apptheme from "@/frame/theme/mixins/apptheme.js";
// eslint-disable-next-line
export default {
  data() {
    return {
      dialog: false
    };
  },
  mixins: [apptheme],
  computed: {
    ...mapGetters(["getTermsAndConditions", "getUser"]),
    iconError() {
      let logic = false;
      if (
        this.getTermsAndConditions === undefined ||
        this.getTermsAndConditions === null
      ) {
        logic = true;
      } else if (
        this.getTermsAndConditions.char.rev !== this.getUser.basic.rtc ||
        this.getUser.basic.rtc === ""
      ) {
        logic = true;
      } else {
        logic = false;
      }
      return logic;
    }
  }
};
</script>
